var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminApp',[_c('div',{staticClass:"Dashboard d-flex flex-column w-100 align-items-center"},[_c('MunicipalityPanel',{staticClass:"Dashboard__Panel mx-3"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }